import React, { useState, useRef } from 'react';
import Modal from './ui/Modal';
import StructureCard from './StructureCard';

const structureData = [
  {
    icon: "icon-coding",
    title: "Board of Advisors",
    subtitle: "Strategic oversight and long-term direction.",
    description: "The Board of Advisors provides strategic leadership and governance for the C2 Community. This group of visionaries and experienced professionals guides the community's long-term direction, ensures alignment with our core values, and provides mentorship to the executive team. They bring diverse expertise from across the creative industries to help shape policies, partnerships, and major initiatives that drive the community forward.",
    benefits: [
      "Set strategic vision and long-term goals",
      "Provide governance and accountability",
      "Mentor executive team and discipline heads",
      "Facilitate high-level partnerships and opportunities",
      "Ensure community values and mission integrity"
    ]
  },
  {
    icon: "icon-design-thinking",
    title: "Executive Team",
    subtitle: "Handles daily management and coordination.",
    description: "The Executive Team manages the day-to-day operations of C2 Community. This dedicated group coordinates events, manages partnerships, oversees community engagement, and ensures smooth operations across all creative circles. They work closely with discipline heads to implement programs, resolve challenges, and create opportunities for members to thrive and collaborate.",
    benefits: [
      "Coordinate community events and programs",
      "Manage partnerships and collaborations",
      "Oversee member engagement and support",
      "Implement strategic initiatives",
      "Facilitate communication across circles"
    ]
  },
  {
    icon: "icon-technology",
    title: "Creative Units",
    subtitle: "C2 circles for music, film, fashion, and more.",
    description: "Creative Units are specialized circles organized by creative field, each led by a Discipline Head. These units provide focused spaces for creatives in music, film, photography, fashion, dance, animation, content creation, and writing to connect, collaborate, and grow. Each circle hosts regular meetups, workshops, showcases, and collaborative projects tailored to their specific discipline.",
    benefits: [
      "Connect with peers in your creative field",
      "Access discipline-specific resources and opportunities",
      "Participate in specialized workshops and events",
      "Collaborate on field-specific projects",
      "Learn from experienced discipline heads"
    ]
  },
  {
    icon: "icon-content",
    title: "Membership Model",
    subtitle: "Different levels of engagement and contribution.",
    description: "C2's membership model offers flexible engagement levels to suit different needs and commitment capacities. From casual participants who attend occasional events, to active members who regularly contribute and collaborate, to core contributors and partners who help shape the community—there's a place for everyone. Each level provides increasing access to resources, networking opportunities, and decision-making influence.",
    benefits: [
      "Flexible engagement based on your availability",
      "Tiered access to events and resources",
      "Opportunities to grow your involvement over time",
      "Recognition for contributions and leadership",
      "Pathways to partnership and collaboration"
    ]
  }
];

const StructureSection = () => {
  const [activeModal, setActiveModal] = useState(null);
  const triggerRefs = useRef([]);

  const openModal = (index) => {
    setActiveModal(index);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      <section className="services-two" id="structure" style={{ backgroundImage: "url(https://images.pexels.com/photos/6192558/pexels-photo-6192558.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)", backgroundSize: "cover", backgroundPosition: "top", backgroundRepeat: "no-repeat", backgroundAttachment: "fixed" }}>
        <div className="service-two__shape-1"></div>
        <div className="service-two__shape-2"></div>
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">How We Organize</span>
              <div className="section-title-shape">
                <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
              </div>
            </div>
            <h2 className="section-title__title">Our Community Structure</h2>
          </div>
          <div className="row">
            {structureData.map((item, index) => (
              <StructureCard
                key={index}
                icon={item.icon}
                title={item.title}
                subtitle={item.subtitle}
                onLearnMore={() => openModal(index)}
                index={index}
                triggerRef={(el) => (triggerRefs.current[index] = el)}
              />
            ))}
          </div>
        </div>
      </section>

      {structureData.map((item, index) => (
        <Modal
          key={index}
          isOpen={activeModal === index}
          onClose={closeModal}
          title={item.title}
          primaryAction={{
            label: 'Join C2 Community',
            onClick: () => {
              closeModal();
              // We'll need to access the Google Form modal from context
              window.dispatchEvent(new CustomEvent('openGoogleFormModal'));
            }
          }}
        >
          <p><strong>{item.subtitle}</strong></p>
          <p>{item.description}</p>
          <h4 style={{ marginTop: '20px', marginBottom: '12px', color: '#33215d' }}>Key Responsibilities & Benefits:</h4>
          <ul style={{ paddingLeft: '20px', marginTop: '12px' }}>
            {item.benefits.map((benefit, i) => (
              <li key={i} style={{ marginBottom: '8px' }}>{benefit}</li>
            ))}
          </ul>
        </Modal>
      ))}
    </>
  );
};

export default StructureSection;
